module.exports = __webpack_public_path__ + "img/zj_station_icon_v2.be1977a3.png";